/**
 * Normalise group-departure pricing from lookup or list APIs into a traveller-facing breakdown.
 */
export function getDeparturePricingBreakdown(departure, travellerCount = 1) {
	if (!departure) return null;

	const perPersonTotal = Number(departure.final_price);
	const perPersonDeposit = Number(departure.interest_amount);
	const perPersonBalanceRaw = departure.balance_amount ?? departure.remaining_payment;
	const perPersonBalance = perPersonBalanceRaw != null
		? Number(perPersonBalanceRaw)
		: (perPersonTotal && perPersonDeposit ? perPersonTotal - perPersonDeposit : null);

	if (!perPersonTotal || !Number.isFinite(perPersonTotal) || !perPersonDeposit || !Number.isFinite(perPersonDeposit)) {
		return null;
	}

	const balance = perPersonBalance != null && Number.isFinite(perPersonBalance)
		? perPersonBalance
		: perPersonTotal - perPersonDeposit;

	const count = Math.max(1, Number(travellerCount) || 1);
	const depositPercent = departure.interest_percentage != null
		? Math.round(Number(departure.interest_percentage))
		: (perPersonTotal > 0 ? Math.round((perPersonDeposit / perPersonTotal) * 100) : null);

	return {
		currencyCode: departure.currency_code || 'USD',
		travellerCount: count,
		perPerson: {
			total: perPersonTotal,
			deposit: perPersonDeposit,
			balance,
			depositPercent,
		},
		totals: {
			total: perPersonTotal * count,
			deposit: perPersonDeposit * count,
			balance: balance * count,
		},
	};
}

export default getDeparturePricingBreakdown;
